<svelte:head>

    <title>Standorte • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../../components/utils/session.svelte";
    import Locations from "../../components/settings/locations/locations.svelte";

</script>

<SessionManager />

<section>

    <Locations />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

</style>
